import AxiosConfig from '../config/axiosConfigApiPlataform'

export const PlataformConteudoApi = {

    async listarCursos (pagina = null, filtro = []) {
        let params = {
            pagina: pagina,
            filtro: filtro
        }
        let response = await AxiosConfig.api().get(`cursos`, params)
        return response.data
    },

    async listarDisciplinas (pagina = null, filtro = []) {
        let params = {
            pagina: pagina,
            filtro: filtro
        }
        let response = await AxiosConfig.api().get(`categorias/disciplinas/cursos`, params)
        return response.data
    },
    async listarLicoes () {
        let response = await AxiosConfig.api().get(`licoes`)
        return response.data
    },
    async listarCategorias () {
        let response = await AxiosConfig.api().get('/categorias/disciplinas/cursos')
        return response.data
    },

    async registraVisualizacaoPdf (resumo) {
        let response = await AxiosConfig.api().post('/resumo_user',{ resumo:resumo })
        return response.data
    }

}

export default PlataformConteudoApi
